var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Right_chevron_18px",
    "data-name": "Right chevron_18px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2266",
    "data-name": "Group 2266"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_737",
    "data-name": "Rectangle 737",
    width: 18,
    height: 18,
    rx: 2,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chevron-right",
    d: "M9,13.566l3.783-3.783L9,6",
    transform: "translate(-2.283 -0.5)",
    fill: "none",
    stroke: "#7f8093",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowIcon);
export default __webpack_public_path__ + "static/media/right-arrow-icon.98e6b49f6cf0202f2006abcedc487cc2.svg";
export { ForwardRef as ReactComponent };